import { render, staticRenderFns } from "./InvoiceStatusChip.vue?vue&type=template&id=af249e4a"
import script from "./InvoiceStatusChip.vue?vue&type=script&lang=js"
export * from "./InvoiceStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports